"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReportingPeriod = void 0;
const Date_1 = require("../types/Date");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isReportingPeriod = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Date_1.Reporting.ReportingPeriodSchema,
    typeguardName: 'isReportingPeriod',
});
//# sourceMappingURL=date.js.map